import React from "react";
import { DEFAULT_PAGE_SIZES, ELLIPSIS, getDisplayedRange, getPageRange } from "./listHelpers";

const TablePagination = ({
  page,
  nbPages,
  count,
  nbItemsByPage,
  onChangePage,
  onChangeNbItemsByPage,
  pageSizes = DEFAULT_PAGE_SIZES,
  itemLabel = "éléments",
  ariaLabel = "Pagination",
}) => {
  const current = Number(page) || 1;
  const total = Math.max(1, Number(nbPages) || 1);
  const { from, to, total: totalCount } = getDisplayedRange(current, nbItemsByPage, count);
  const range = getPageRange(current, total);

  return (
    <nav className="table-pagination" aria-label={ariaLabel}>
      <p className="table-pagination__range" data-testid="pagination-range">
        {totalCount === 0
          ? `0 ${itemLabel}`
          : `${from}–${to} sur ${totalCount.toLocaleString("fr-FR")} ${itemLabel}`}
      </p>
      {total > 1 && (
        <ul className="table-pagination__pages">
          <li>
            <button
              type="button"
              className="table-pagination__page table-pagination__page--nav"
              onClick={() => onChangePage(current - 1)}
              disabled={current <= 1}
              aria-label="Page précédente"
            >
              <i className="fa fa-chevron-left" aria-hidden="true" />
              <span className="table-pagination__nav-text">Précédent</span>
            </button>
          </li>
          {range.map((p, i) =>
            p === ELLIPSIS ? (
              <li key={`ellipsis-${i}`} className="table-pagination__ellipsis" aria-hidden="true">
                {ELLIPSIS}
              </li>
            ) : (
              <li key={p}>
                <button
                  type="button"
                  className="table-pagination__page"
                  onClick={() => onChangePage(p)}
                  aria-current={p === current ? "page" : undefined}
                  aria-label={`Page ${p}`}
                >
                  {p}
                </button>
              </li>
            )
          )}
          <li>
            <button
              type="button"
              className="table-pagination__page table-pagination__page--nav"
              onClick={() => onChangePage(current + 1)}
              disabled={current >= total}
              aria-label="Page suivante"
            >
              <span className="table-pagination__nav-text">Suivant</span>
              <i className="fa fa-chevron-right" aria-hidden="true" />
            </button>
          </li>
        </ul>
      )}
      <label className="table-pagination__size">
        Par page
        <select
          className="form-control form-control-sm"
          value={Number(nbItemsByPage) || pageSizes[0]}
          onChange={(e) => onChangeNbItemsByPage(Number(e.target.value))}
        >
          {pageSizes.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
      </label>
    </nav>
  );
};

export default TablePagination;
